import { useLocale } from "@hooks";
import { ListSelectorItem, MultiSelect, SingleSelect } from "@bonliva-crm/ui";
import { useGetUserSelectUsersQuery } from "@bonliva-crm/graphql";

type UserSelectorModalProps = {
  value: ListSelectorItem | ListSelectorItem[];
  excludeUserIds?: string[];
  isMulti?: boolean;
  onChange: (value: ListSelectorItem | ListSelectorItem[]) => void;
};

export function UserSelect(props: UserSelectorModalProps) {
  const { locale } = useLocale();

  const { data, loading } = useGetUserSelectUsersQuery({
    fetchPolicy: "cache-and-network"
  });

  const options = data?.users
    .filter((user) => !props.excludeUserIds?.includes(user._id))
    .map((user) => ({ label: user.Name, value: user._id }));

  return props.isMulti ? (
    <MultiSelect
      placeholder=""
      inputLabel={locale.selectUser}
      value={props.value}
      isLoading={loading}
      onChange={(value) => props.onChange(value as ListSelectorItem[])}
      styleProps={{
        control: { showBorder: true },
        menu: { showBorder: true },
        menuPortal: { zIndex: 9999 }
      }}
      options={options}
      isClearable={true}
      labelShrink={true}
      menuPortalTarget={document.body}
    />
  ) : (
    <SingleSelect
      placeholder=""
      inputLabel={locale.selectUser}
      value={props.value}
      isLoading={loading}
      onChange={(value) => props.onChange(value)}
      styleProps={{
        control: { showBorder: true },
        menu: { showBorder: true },
        menuPortal: { zIndex: 9999 }
      }}
      options={options}
      isClearable={true}
      labelShrink={true}
      menuPortalTarget={document.body}
    />
  );
}
